import { render } from "./FormLoginComponent.vue?vue&type=template&id=08090708&scoped=true"
import script from "./FormLoginComponent.vue?vue&type=script&lang=js"
export * from "./FormLoginComponent.vue?vue&type=script&lang=js"

import "./FormLoginComponent.vue?vue&type=style&index=0&id=08090708&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08090708"]])

export default __exports__